import { render, staticRenderFns } from "./listPersonnelBasicSearch.vue?vue&type=template&id=2383d914&scoped=true&"
import script from "./listPersonnelBasicSearch.vue?vue&type=script&lang=js&"
export * from "./listPersonnelBasicSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383d914",
  null
  
)

export default component.exports